import { render, staticRenderFns } from "./Assets.vue?vue&type=template&id=a4f9e1c4&scoped=true&"
import script from "./Assets.vue?vue&type=script&lang=ts&"
export * from "./Assets.vue?vue&type=script&lang=ts&"
import style0 from "./Assets.vue?vue&type=style&index=0&id=a4f9e1c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f9e1c4",
  null
  
)

export default component.exports